/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScenarioReason
 */
export interface ApiScenarioReason {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiScenarioReason
     */
    scenarioIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ApiScenarioReason
     */
    name?: string;
}

/**
 * Check if a given object implements the ApiScenarioReason interface.
 */
export function instanceOfApiScenarioReason(value: object): value is ApiScenarioReason {
    return true;
}

export function ApiScenarioReasonFromJSON(json: any): ApiScenarioReason {
    return ApiScenarioReasonFromJSONTyped(json, false);
}

export function ApiScenarioReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScenarioReason {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioIds': json['scenario_ids'] == null ? undefined : json['scenario_ids'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ApiScenarioReasonToJSON(json: any): ApiScenarioReason {
    return ApiScenarioReasonToJSONTyped(json, false);
}

export function ApiScenarioReasonToJSONTyped(value?: ApiScenarioReason | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenario_ids': value['scenarioIds'],
        'name': value['name'],
    };
}

